export enum AuthErrorsActions {
    SAVE_ERRORS = 'authErrors/SAVE_ERRORS',
    RESET_ERROR = 'auth/RESET_ERROR',
}

export const saveAuthErrors = (payload: Record<string, { code: string }>) => ({
    payload,
    type: AuthErrorsActions.SAVE_ERRORS,
})
export const resetAuthErrors = () => ({
    type: AuthErrorsActions.RESET_ERROR,
})
